import { CONTENT_CATEGORIES } from "@/data/curatedContent";

interface FeedSidebarProps {
  activeCategory: string | null;
  onCategoryChange: (cat: string | null) => void;
}

export function FeedSidebar({ activeCategory, onCategoryChange }: FeedSidebarProps) {
  return (
    <div style={{ width: 300 }} className="shrink-0 hidden lg:block">
      {/* Search */}
      <input
        type="text"
        placeholder="Search ideas..."
        className="w-full rounded-md border border-border bg-input px-3 text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring"
        style={{ height: 40, fontSize: 14, marginBottom: 24 }}
      />

      {/* Filter by category */}
      <div style={{ marginBottom: 32 }}>
        <h4
          className="text-muted-foreground font-semibold uppercase tracking-wide"
          style={{ fontSize: 14, marginBottom: 12 }}
        >
          Categories
        </h4>
        <div className="flex flex-wrap" style={{ gap: 8 }}>
          {CONTENT_CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategoryChange(activeCategory === cat ? null : cat)}
              className={`rounded-full border px-3 py-1 text-sm transition-colors ${
                activeCategory === cat
                  ? "bg-primary text-primary-foreground border-primary"
                  : "border-border text-muted-foreground hover:text-foreground hover:border-foreground/30"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Collections */}
      <div style={{ marginBottom: 32 }}>
        <h4
          className="text-muted-foreground font-semibold uppercase tracking-wide"
          style={{ fontSize: 14, marginBottom: 12 }}
        >
          Collections
        </h4>
        <ul className="space-y-3">
          <li className="text-foreground text-sm cursor-pointer hover:text-primary transition-colors">🔥 Trending This Week</li>
          <li className="text-foreground text-sm cursor-pointer hover:text-primary transition-colors">⚡ Quick Wins</li>
          <li className="text-foreground text-sm cursor-pointer hover:text-primary transition-colors">🧠 Deep Dives</li>
          <li className="text-foreground text-sm cursor-pointer hover:text-primary transition-colors">🆕 Latest Additions</li>
        </ul>
      </div>
    </div>
  );
}
